import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import ViewInquiry from "../../VIewInquiry/ViewInquiry";
import {Link} from "react-router-dom";

class InquiriesPerUserRow extends Component {

    viewItemClicked = () => {
        // console.log("Clicked View Item ..");
    };

    replyItemClicked = () => {
        // console.log("Clicked Reply Item ..");
    };

    render() {
        return (
            <tr>
                <td> {this.props.no}</td>
                <td>
                    {this.props.inquiry.createdDate.substring(0,4)}年 {this.props.inquiry.createdDate.substring(5,7)}月 {this.props.inquiry.createdDate.substring(8,10)}日

                </td>
                <td>
                    <span style={{overflow: 'hidden', textOverflow: 'hidden'}}>
                            {this.props.inquiry.subject==='QUOTATION_RELATED' ?
                                <span>お見積りに関するご質問</span>:
                                this.props.inquiry.subject==='PRODUCTION_RELATED' ?
                                    <span>製造基準・技術的に関するご質問</span>:
                                    this.props.inquiry.subject==='PRICING_RELATED' ?
                                        <span>ご注文やサービスご利用に関するご質問</span>:
                                        this.props.inquiry.subject==='PAYMENT_RELATED' ?
                                            <span>お支払いに関するご質問</span>:
                                            this.props.inquiry.subject==='QUALITY_RELATED' ?
                                                <span>出荷に関するご質問</span>:
                                                this.props.inquiry.subject === 'REQUEST' ? <text>無料基板サンプル請求</text> : <text>その他</text>

                            }
                        </span>
                </td>
                <td>
                    {this.props.inquiry.status === "NEW" &&
                    <h5 className="inquiry-status-view">NEW</h5>
                    }
                </td>
                <td>
                    <ViewInquiry inquiryData={this.props.inquiry} getAll={this.props.getAll}/>
                </td>
            </tr>

        )
    }
}

export default InquiriesPerUserRow;



// WEBPACK FOOTER //
// ./src/components/Admin/InquiriesPerUser/InquiriesPerUserRow/InquiriesPerUserRow.js